module.exports = __webpack_public_path__ + "static/img/xiaomuIcon.502c729.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xiaomuIcon.png
// module id = USmv
// module chunks = 1